export function ZaloIcon({ className }: { className?: string }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" className={className} xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 17.703c0 .467-.379.846-.846.846H6.952a.846.846 0 01-.846-.846v-1.47a.846.846 0 01.248-.598l5.473-5.517H7.42a.423.423 0 010-.846h6.578c.467 0 .846.379.846.846v1.102a.846.846 0 01-.248.598l-5.397 5.44h5.847c.234 0 .423.19.423.424v.021h2.425zm-1.47-7.615a1.27 1.27 0 110-2.539 1.27 1.27 0 010 2.539z" />
        </svg>
    );
}
